import { render, staticRenderFns } from "./applyFor.vue?vue&type=template&id=2dc4a1c5&"
import script from "./applyFor.vue?vue&type=script&lang=js&"
export * from "./applyFor.vue?vue&type=script&lang=js&"
import style0 from "./applyFor.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports